module.exports = __webpack_public_path__ + "static/media/video_play.58ca46bb.png";